import React from "react";
import { useLocation } from "react-router-dom";

import { Loader, SearchBar, classnames } from "@culturehq/components";
import useTrendScreen from "app/hooks/useTrendScreen";
import TrendList from "./trends/TrendList";
import DiscoverStories from "./stories/DiscoverStories";
import StartTheTrend from "./stories/StartTheTrend";

const PrincipalClasses = classnames("principal", "col-xs-12", "col-md-8");
const SecondaryClasses = classnames("secondary", "hidden-xs", "hidden-sm", "col-md-4");

const Title = () => <h3 className="title">Story Trends</h3>;
const Layout = ({ children }) => <div className="TrendLayout">{children}</div>;
const Content = ({ children }) => <div className="Content">{children}</div>;
const Principal = ({ children }) => <div className={PrincipalClasses}>{children}</div>;
const Secondary = ({ children }) => <div className={SecondaryClasses}>{children}</div>;

const Trends = () => {
  const location = useLocation();

  const [
    { storyQuestions, fetching },
    { handleSearch, handleNextPage }
  ] = useTrendScreen();

  const { isProfile } = location.state || {};

  return (
    <Layout>
      <Content>
        <Principal>
          <Title />
          <SearchBar placeholder="Search prompt" throttle={500} onSearch={handleSearch} />
          <TrendList
            storyQuestions={storyQuestions}
            lazyContainerRef={document}
            onNextPage={handleNextPage}
            isProfile={isProfile}
          />
          {fetching && <Loader loading={fetching} />}
        </Principal>
        <Secondary>
          <DiscoverStories title="What's Trending Now" icon="fire" />
          <StartTheTrend title="What's New" icon="new" />
        </Secondary>
      </Content>
    </Layout>
  );
};

export default Trends;
